// extracted by mini-css-extract-plugin
export var downArrow = "_7j-0";
export var infoTooltipIcon = "_7j-3";
export var label = "_7j-1";
export var optionCard = "_7j-4";
export var upArrow = "_7j-2";